/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import registrationConfig from './registration.config.js';
import registrationRoute from './registration.route.js';
import registrationController from './registration.controller.js';
import registrationService from './registration.service.js';
import registrationDataService from './registration.data.service.js';

/**
 * This is the registration module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace registration Module
 */
angular.module('registration', [
  // Shared modules.
  core
])
// Register config.
.config(registrationConfig)
// Register route.
.config(registrationRoute)
// Register controller.
.controller('registrationController', registrationController)
// Register service.
.factory('registrationService', registrationService)
// Register data service.
.factory('registrationDataService', registrationDataService);

export default 'registration';


// WEBPACK FOOTER //
// ./src/login/registration/registration.module.js